// @flow
import ImageGallery from "react-image-gallery"
import "./style.css"

export default ImageGallery



// WEBPACK FOOTER //
// ./src/pages/Affiliate/Content/ImageGallery/index.js